import { FILTER_TYPES } from './constants';
import { updateFilterState, resetFilterState } from './reducers';
import MetricState from './MetricState';

export const createHandlers = (setFilterState, setUIState) => ({
  handleFilterSelect: (type, value, isMultiSelect = false) => {
    // Handle "All" selections by resetting that filter
    if (value === 'All Organizations' || 
        value === 'All Roles' || 
        value === 'All Locations' || 
        value === 'All Status' || 
        value === 'All Domains') {
      setFilterState(prev => ({
        ...prev,
        [type]: []
      }));
      // Reset UI state for status filters
      if (type === FILTER_TYPES.STATUS) {
        setUIState(prev => ({
          ...prev,
          activeMetric: 'total'
        }));
      }
      return;
    }

    // Special handling for status filters
    if (type === FILTER_TYPES.STATUS) {
      let newStatuses;
      setFilterState(prev => {
        const currentStatuses = prev[FILTER_TYPES.STATUS] || [];
        const isRemoving = currentStatuses.includes(value);
        newStatuses = isRemoving 
          ? currentStatuses.filter(s => s !== value)
          : [...currentStatuses, value];

        return {
          ...prev,
          [FILTER_TYPES.STATUS]: newStatuses,
          created_at: null
        };
      });

      // Update UI state based on new filter state
      setUIState(prev => ({
        ...prev,
        activeMetric: newStatuses.length === 0 ? 'total' : value
      }));
      return;
    }

    setFilterState(prev => updateFilterState(prev, type, value, isMultiSelect));
  },

  handleSearch: (query) => {
    setUIState(prev => ({
      ...prev,
      searchQuery: query,
      openFilter: null
    }));
  },

  handleReset: () => {
    setFilterState(resetFilterState);
    setUIState(prev => ({
      ...prev,
      searchQuery: '',
      openFilter: null,
      activeMetric: 'total'
    }));
  },

  handleMetricClick: (metricType) => {
    let transition = null;

    // Get current state and determine transition
    setUIState(prev => {
      transition = MetricState.transition(prev.activeMetric, metricType);
      return transition.requiresUIUpdate ? transition.newUIState(prev) : prev;
    });

    // Apply filter update if needed
    if (transition.requiresFilterUpdate) {
      setFilterState(prev => transition.newFilterState(prev));
    }
  },

  handleOpenFilter: (filterType) => {
    setUIState(prev => ({
      ...prev,
      openFilter: prev.openFilter === filterType ? null : filterType
    }));
  }
}); 